// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__MJ2km","left":"StickyBox_left__26a1o","right":"StickyBox_right__2FCgu"};